<template>
  <div>
    <el-dialog title="用户流水" :visible.sync="dialogVisible" width="1100px">
      <div class="filter-actions">
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
      </div>
      <div class="filter-grid">
        <!-- <el-input v-model.trim="queryForm.order_id" size="small" placeholder="搜索账单单号" /> -->
        <!-- <el-select v-model="queryForm.biz_type" clearable size="small" placeholder="业务类型">
          <el-option label="ad_income_user" value="ad_income_user" />
          <el-option label="ad_income_platform" value="ad_income_platform" />
        </el-select> -->
        <!-- <el-select v-model="queryForm.source_type" clearable size="small" placeholder="来源类型">
          <el-option label="accessad" value="accessad" />
        </el-select> -->
        <!-- <el-select v-model="queryForm.biz_status" clearable size="small" placeholder="业务状态">
          <el-option label="confirmed" value="confirmed" />
        </el-select> -->
        <el-select
          v-model="queryForm.is_app"
          clearable
          size="small"
          placeholder="收益归属"
        >
          <el-option label="用户收益" value="0" />
          <el-option label="平台收益" value="1" />
        </el-select>
        <el-select
          v-model="queryForm.type"
          clearable
          size="small"
          placeholder="增减方向"
        >
          <el-option label="increase" value="increase" />
          <el-option label="decrease" value="decrease" />
        </el-select>
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          size="small"
          value-format="timestamp"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="handleTimeChange"
        />
      </div>

      <BillTable :list="list" :loading="loading" :showUserColumn="false" />

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryForm.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryForm.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BillTable from "@/components/bill/components/BillTable.vue";

export default {
  components: {
    BillTable,
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      total: 0,
      list: [],
      timeRange: [],
      queryForm: {
        user_id: "",
        page: 1,
        page_size: 10,
        order_id: "",
        biz_type: "",
        source_type: "",
        biz_status: "",
        is_app: "",
        type: "",
        start_time: "",
        end_time: "",
      },
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const data = await this.$api.getBill.getBillList(this.queryForm);
        this.total = data.data && data.data.count ? data.data.count : 0;
        this.list = data.data && data.data.list ? data.data.list : [];
      } finally {
        this.loading = false;
      }
    },
    open(userId) {
      this.queryForm = {
        user_id: userId,
        page: 1,
        page_size: 10,
        order_id: "",
        biz_type: "",
        source_type: "",
        biz_status: "",
        is_app: "",
        type: "",
        start_time: "",
        end_time: "",
      };
      this.timeRange = [];
      this.dialogVisible = true;
      this.getList();
    },
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.queryForm.page_size = size;
      this.queryForm.page = 1;
      this.getList();
    },
    handleTimeChange(value) {
      if (!value) {
        this.queryForm.start_time = "";
        this.queryForm.end_time = "";
        return;
      }
      this.queryForm.start_time = Math.floor(Number(value[0]) / 1000);
      this.queryForm.end_time = Math.floor(Number(value[1]) / 1000);
    },
    search() {
      this.queryForm.page = 1;
      this.getList();
    },
    resetSearch() {
      const userId = this.queryForm.user_id;
      this.queryForm = {
        user_id: userId,
        page: 1,
        page_size: 10,
        order_id: "",
        biz_type: "",
        source_type: "",
        biz_status: "",
        is_app: "",
        type: "",
        start_time: "",
        end_time: "",
      };
      this.timeRange = [];
      this.getList();
    },
  },
};
</script>

<style scoped>
.filter-grid {
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  align-items: center;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.pagination {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
}
</style>
